import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../../components/Loading/Spinner";
import { useCreateObjetivo } from "../../../context/SuperAdmin/OASContexts/CreateObjetivoContext";
import ObjetivoForm from "../../../components/Table/OAS/Objetivos/ObjetivoForm";
import IndicadoresForm from "../../../components/Table/OAS/Objetivos/IndicadoresForm";

const CreateObjetivo = () => {
  const navigate = useNavigate();
  const { isLoadingNiveles, objetivoCreate, isFormValid } = useCreateObjetivo();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#336B87",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Objetivos</b> | Crear objetivo
        </Typography>
      </Grid>

      {isLoadingNiveles ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Form objetivo */}
          <Grid item>
            <ObjetivoForm />
          </Grid>

          {/* Form indicadores */}
          <Grid item>
            <IndicadoresForm />
          </Grid>

          {/* Botón de crear objetivo */}
          <Grid item display={"flex"} justifyContent={"start"}>
            <Button
              onClick={objetivoCreate}
              variant="contained"
              sx={{ background: "#336B87" }}
              disabled={!isFormValid}
            >
              Crear Objetivo
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CreateObjetivo;
